var map = {
	"./ad.js": "fee0",
	"./dashboard.js": "76b5",
	"./logistics.js": "ff78",
	"./product.js": "c2ff",
	"./purchase.js": "b91e",
	"./sale.js": "09cd",
	"./statistics.js": "100d",
	"./user.js": "0f9a",
	"./warehouse.js": "efa0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c653";